// import { useEffect, useState } from 'react'
import MiniMainCard from './MiniMainCard';

const MainCard = ({ MainTitle, data, statusObj }) => {


    // const statusColorClass = status ?  : 'text-cyan-400';

    // const [statusColour, setStatusColour] = useState('');

    // useEffect(() => {
    //     if (statusObj && statusObj.colour) {
    //         setStatusColour(statusObj.colour);
    //     }
    // }, [statusObj]);

    return (
        <div className='w-full h-48 md:h-48 md:w-72 2xl:h-56 2xl:w-96 p-4 text-[12px] md:text-[12px] 2xl:text-[14px] border-2 border-dividerLines bg-secondaryBg rounded-md'>
            {/* <div className=' px-[15px] pt-[12px] text-xs 2xl:text-base text-[#1E253E] font-bold'> */}
            {MainTitle ? (
                <>
                    <div className='flex justify-between'>
                        <span className='capitalize font-bold text-[14px] 2xl:text-base'>
                            {MainTitle}
                        </span>
                        <span>
                            {statusObj ? <span className='text-rose-400'>{`${statusObj.statusText}`}</span> : null}
                        </span>
                    </div>
                </>
            )
                : '--'
            }
            <hr className=" my-2 h-[1px] border-t-0 bg-dividerLines " />
            <MiniMainCard
                miniCardData={data}
            />
            {/* </div> */}
        </div >
    )
}

// Skip prop validation by setting propTypes to null
MainCard.propTypes = null;

export default MainCard